"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var deviceHelper_1 = require("../../../../helpers/deviceHelper");
var classnames_1 = __importDefault(require("classnames"));
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../../../features/global/globalSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var PropertyTypes_1 = require("../../../../types/SearchPage/PropertyTypes");
var PersonalPostViewNavigation = function (_a) {
    var _b, _c, _d;
    var _e;
    var tabIsShown = _a.tabIsShown, handleChangeTab = _a.handleChangeTab, handleClick = _a.handleClick, checkNavHeight = _a.checkNavHeight, isRent = _a.isRent, propertyType = _a.propertyType;
    var sectionNavRef = react_1.useRef(null);
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var isMortgageCalcIconClicked = react_redux_1.useSelector(globalSlice_1.getIsMortgageCalcIconClicked);
    // Label of the first tab by property type; unknown types fall back to apartment.
    var getObjectTabLabel = function () {
        if (propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO) {
            return t('POST_PREVIEW.HOUSE_INFO');
        }
        if (propertyType === PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO) {
            return t('POST_PREVIEW.COMMERCIAL_INFO');
        }
        if (propertyType === PropertyTypes_1.PROPERTY_TYPE.LAND) {
            return t('POST_PREVIEW.LAND_INFO');
        }
        return t('POST_PREVIEW.APARTMENT_INFO');
    };
    react_1.useEffect(function () {
        sectionNavRef.current &&
            checkNavHeight(deviceHelper_1.isMobile()
                ? sectionNavRef.current.offsetHeight
                : sectionNavRef.current.offsetHeight * 2);
    }, [(_e = sectionNavRef.current) === null || _e === void 0 ? void 0 : _e.offsetHeight]);
    react_1.useEffect(function () {
        if (isMortgageCalcIconClicked) {
            handleChangeTab(PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO);
            handleClick(true);
            dispatch(globalSlice_1.setIsMortgageCalcIconClicked(false));
        }
        if (tabIsShown !== PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO) {
            dispatch(globalSlice_1.setIsMortgageCalcIconClicked(false));
        }
    }, [isMortgageCalcIconClicked, tabIsShown]);
    return (react_1.default.createElement("div", { className: classnames_1.default('section-nav', styles_module_scss_1.default.navigation_section), ref: sectionNavRef },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.navigation_box },
            react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_b = {},
                    _b[styles_module_scss_1.default.active] = tabIsShown === PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO,
                    _b)), onClick: function () {
                    handleChangeTab(PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO);
                    handleClick(true);
                } }, getObjectTabLabel()),
            propertyType !== PropertyTypes_1.PROPERTY_TYPE.LAND && (react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_c = {},
                    _c[styles_module_scss_1.default.active] = tabIsShown === PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO,
                    _c)), onClick: function () {
                    handleChangeTab(PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO);
                    handleClick(true);
                } }, t('POST_PREVIEW.BUILDING_INFO'))),
            !isRent && propertyType !== GeneralSettings_1.PROPERTY_TYPES.COMMERCIAL && (react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_d = {},
                    _d[styles_module_scss_1.default.active] = tabIsShown === PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO,
                    _d)), onClick: function () {
                    handleChangeTab(PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO);
                    handleClick(true);
                } }, t('MORTGAGE_BUTTON.SECONDARY_TEXT'))))));
};
exports.default = PersonalPostViewNavigation;
